import {
  Group,
  Box,
  Divider,
  HoverCard,
  Center,
  useMantineTheme,
  Text,
  UnstyledButton,
  ThemeIcon,
  SimpleGrid,
} from "@mantine/core";

import { IconChevronDown } from "@tabler/icons";


export const HeaderMegaMenu = (props) => {
  const theme = useMantineTheme();

  const subLinks = props?.mockdata.map((item) => (
    <UnstyledButton
      component="a"
      href={item.link}
      className={props?.classes.subLink}
      key={item.title}
    >
      <Group wrap="nowrap" align="flex-start">
        <ThemeIcon size={34} variant="default" radius="md">
          <item.icon size={22} color={theme.colors.blue[6]} />
        </ThemeIcon>
        <div>
          <Text size="sm" fw={500}>
            {item.title}
          </Text>
          <Text size="xs" c="dimmed">
            {item.description}
          </Text>
        </div>
      </Group>
    </UnstyledButton>
  ));
  return (
    <HoverCard
      width={600}
      position="bottom"
      radius="md"
      shadow="md"
      withinPortal
    >
      <HoverCard.Target>
        <a href="#" className={props?.classes.link}>
          <Center inline>
            <Box component="span" mr={5}>
              פתרונות לפי תחום
            </Box>
            <IconChevronDown size={16} color={theme.colors.blue[6]} />
          </Center>
        </a>
      </HoverCard.Target>

      <HoverCard.Dropdown style={{ overflow: "hidden" }}>
        <Group justify="space-between" px="md">
          <Text fw={500}>פתרונות לפי תחום</Text>
        </Group>

        <Divider my="sm" />

        <SimpleGrid cols={2} spacing={0}>
          {subLinks}
        </SimpleGrid>

        {/* <div className={props?.classes.dropdownFooter}>
    <Group justify="flex-end">
      <div>
        <Image
          src="/whatsapp-reminder2.png"
          alt="ניהול תורים לקוסמטיקאיות"
   width={400}
   height={300}
          radius="md"
        />

      </div>
      {/* <Button variant="default">Get started</Button> */}
        {/* </Group>
  </div>  */}
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
